import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PatientDetailICU from "./patientDetailComponents/PatientDetailICU";
import PatientDetailOB from "./patientDetailComponents/PatientDetailOB";
import PatientDetailOR from "./patientDetailComponents/PatientDetailOR";
import PatientDetailPACU from "./patientDetailComponents/PatientDetailPACU";

@Component({
  components: {
    PatientDetailOR,
    PatientDetailOB,
    PatientDetailICU,
    PatientDetailPACU
  }
})
export default class PatientDetailBody extends Vue {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("now", patientNamespace)
  now: any;

  @Prop(Object)
  data!: Patient;

  get bmiRisk() {
    return this.config.body.patientDetailBmi;
  }

  get ReleasedFromCareTime(): string {
    return this.data.body.atoms.releasedFromCare && this.data.body.atoms.releasedFromCare.age > 0 ?  ("0" + new Date(this.data.body.atoms.releasedFromCare.time).getHours().toString()).slice(-2) + ":" + ("0" + new Date(this.data.body.atoms.releasedFromCare.time).getMinutes().toString()).slice(-2) : "N/A";
  }
}
